var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalAlignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3081 4304 c-169 -45 -301 -180 -346 -351 -23 -87 -22 -2700 0 -2788 45 -172 179 -305 352 -350 83 -22 623 -22 706 0 173 45 307 178 352 350 13 52 15 228 15 1395 0 1167 -2 1343 -15 1395 -45 172 -179 305 -352 350 -81 21 -633 20 -712 -1z m729 -172 c72 -35 114 -75 151 -144 l34 -63 0 -1365 0 -1365 -34 -63 c-38 -70 -69 -100 -145 -140 l-51 -27 -325 0 -325 0 -63 34 c-69 37 -109 79 -144 151 l-23 45 0 1365 0 1365 25 50 c42 86 124 153 215 176 17 4 167 7 335 6 295 -2 307 -3 350 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321 3664 c-169 -45 -301 -180 -346 -351 -22 -85 -22 -1421 0 -1506 45 -173 178 -307 350 -352 86 -22 624 -22 710 0 172 45 305 179 350 352 23 86 22 1421 0 1508 -45 172 -179 305 -352 350 -81 21 -633 20 -712 -1z m729 -172 c72 -35 114 -75 151 -144 l34 -63 0 -725 0 -725 -27 -51 c-40 -76 -70 -107 -140 -145 l-63 -34 -325 0 -325 0 -63 34 c-69 37 -109 79 -144 151 l-23 45 0 725 0 725 25 50 c42 86 124 153 215 176 17 4 167 7 335 6 295 -2 307 -3 350 -25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalAlignment);
export default __webpack_public_path__ + "static/media/vertical-alignment.ade9c9388f7ec6c9e44645ee51b2caf7.svg";
export { ForwardRef as ReactComponent };